import { render, staticRenderFns } from "./MainDetails.vue?vue&type=template&id=f6e75aaa"
import script from "./MainDetails.vue?vue&type=script&lang=js"
export * from "./MainDetails.vue?vue&type=script&lang=js"
import style0 from "./MainDetails.vue?vue&type=style&index=0&id=f6e75aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports